import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';

const RegistrarRegionales = () => {
    const { id } = useParams();
    const navigate = useNavigate(); // ✅ corregido

    const [codRegional, setCodRegional] = useState('');
    const [nombreRegional, setNombreRegional] = useState('');

    const cleanData = () => {
        setCodRegional('');
        setNombreRegional('');
    };

    // Obtener datos si existe ID
    const getData = useCallback(async () => {
        try {
            const response = await axios.get(`/api/regionales/listid/${id}`);
            if (response.data.ok) {
                setCodRegional(response.data.regional.codRegional);
                setNombreRegional(response.data.regional.nombreRegional);
            }
        } catch (error) {
            console.error('Error al obtener datos:', error.message);
            Swal.fire('Error', 'No se pudo cargar la regional', 'error');
        }
    }, [id]);

    useEffect(() => {
        if (id) {
            getData();
        }
    }, [id, getData]);


    const saveRegional = async () => {
        try {
            const newRegional = { codRegional, nombreRegional };
            await axios.post('/api/regionales/add', newRegional);
            cleanData();

            Swal.fire({
                icon: 'success',
                title: 'La Regional ha sido registrada con éxito',
                showConfirmButton: false,
                timer: 1500
            });

        } catch (error) {
            if (error.response?.data?.message) {
                return alert(error.response.data.message);
            }
            console.error('Error en saveRegional:', error.message);
        }
    };

    // Actualizar regional existente
    const updateRegional = async () => {
        try {
            const updatedRegional = { codRegional, nombreRegional };
            const { data } = await axios.put(`/api/regionales/update/${id}`, updatedRegional);

            cleanData();

            Swal.fire({
                icon: 'success',
                title: data.message || 'Regional actualizada con éxito',
                showConfirmButton: false,
                timer: 1500
            }).then(() => {
                navigate('/institucional/regional/'); // ✅ navegación sin recargar
            });

        } catch (error) {
            if (error.response?.data?.message) {
                return alert(error.response.data.message);
            }
            console.error('Error al actualizar la regional:', error.message);
        }
    };

    const actions = async (e) => {
        e.preventDefault();
        id ? await updateRegional() : await saveRegional();
    };

    return (
        <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
            < div className='container-fluid mt-3' >
                <h1>Registrar Regionales</h1>
            </div>

            <div className='mb-5'>
                <form onSubmit={actions}>
                    <div className="container">
                        <div className="row g-3 align-items-end justify-content-center">
                            {/* Campo de Código */}
                            <div className="col-md-4">
                                <label htmlFor="codigo" className="form-label">Código</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="codigo"
                                    value={codRegional}
                                    onChange={(e) => setCodRegional(e.target.value)}
                                    placeholder="Ingrese código"
                                    required
                                />
                            </div>

                            {/* Campo de Nombre Regional */}
                            <div className="col-md-4">
                                <label htmlFor="nombreregional" className="form-label">Regional</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="nombreregional"
                                    value={nombreRegional}
                                    onChange={(e) => setNombreRegional(e.target.value)}
                                    placeholder="Ingrese regional"
                                    required
                                />
                            </div>
                        </div>

                        {/* Botón de envío */}
                        <div className="col-12 mt-4">
                            <div className="row g-3">
                                <div className="col-12 col-md-6">
                                    <button type="submit" className="btn btn-success w-100">{id ? 'Actualizar' : 'Enviar'}</button>
                                </div>
                                <div className="col-12 col-md-6">
                                    <button type="button" className="btn btn-danger w-100" onClick={cleanData}>
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    );
};

export default RegistrarRegionales;
